import { useEffect } from 'react';

const isEditableTarget = (target) => {
    if (!target || !(target instanceof Element)) return false;
    return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
};

/**
 * Desktop arrow-key navigation: ArrowLeft = previous, ArrowRight = next.
 */
export function useAlbumArrowKeys(onPrev, onNext) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (isEditableTarget(e.target)) return;

            const isNext = e.key === 'ArrowRight' || e.code === 'ArrowRight';
            const isPrev = e.key === 'ArrowLeft' || e.code === 'ArrowLeft';
            if (!isNext && !isPrev) return;

            e.preventDefault();
            if (isNext) {
                onNext();
            } else {
                onPrev();
            }
        };

        document.addEventListener('keydown', handleKeyDown, true);
        return () => document.removeEventListener('keydown', handleKeyDown, true);
    }, [onPrev, onNext]);
}
